{
  "DarkMode_Switch_Title": "Mode sombre",
  "NAME": "DarkMode",
  "DarkMode_SwitchLight_Title": "Mode lumière"
}